import {SvgIcon} from './SvgIcon'

export const SparkleIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M8 1.5L9.15 5.1L12.75 6.25L9.15 7.4L8 11L6.85 7.4L3.25 6.25L6.85 5.1L8 1.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M12.25 10.25L12.85 12.05L14.65 12.65L12.85 13.25L12.25 15.05L11.65 13.25L9.85 12.65L11.65 12.05L12.25 10.25Z"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinejoin="round"
    />
    <path
      d="M2.75 10.5L3.15 11.7L4.35 12.1L3.15 12.5L2.75 13.7L2.35 12.5L1.15 12.1L2.35 11.7L2.75 10.5Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
  </svg>
)

export const ThreeDBoxIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M8 1.75L13.25 4.5V11.5L8 14.25L2.75 11.5V4.5L8 1.75Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M2.75 4.5L8 7.25L13.25 4.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.25V14.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M5.35 3.1L10.6 5.85"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.75"
    />
  </svg>
)

export const UploadToCloudIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M5.25 12.75H4.25C2.73122 12.75 1.5 11.5188 1.5 10C1.5 8.63703 2.49138 7.50547 3.79199 7.28735C4.13219 5.17378 5.96303 3.5625 8.1725 3.5625C10.3005 3.5625 12.0828 5.0589 12.5206 7.05564C13.6562 7.42186 14.5 8.48649 14.5 9.75C14.5 11.4069 13.1569 12.75 11.5 12.75H10.75"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 13.75V8.25"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M5.75 10.5L8 8.25L10.25 10.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BlockIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeWidth = 1.5,
  classes,
  ariaLabel,
  datacy = 'block-icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-hidden={ariaLabel ? undefined : true}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <circle
      cx="8"
      cy="8"
      r="6.25"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M12.42 3.58L3.58 12.42"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
  </svg>
)

export const UnblockIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeWidth = 1.5,
  classes,
  ariaLabel,
  datacy = 'unblock-icon',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-hidden={ariaLabel ? undefined : true}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <circle
      cx="8"
      cy="8"
      r="6.25"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M5.25 8.4L7.1 10.15L10.85 6.2"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
